var map = {
	"./text_record_01.png": "d5d7",
	"./text_record_02.png": "464f",
	"./text_record_03.png": "0aa6",
	"./text_record_04.png": "6e40",
	"./text_record_05.png": "c973",
	"./text_record_06.png": "6b2a",
	"./text_record_07.png": "6ee0",
	"./text_record_07_close.png": "8512"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0351";